import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ReactiveForm } from 'src/app/core/resources/reactive-form';
import { Utils } from 'src/app/core/resources/utils';
import { CargoGenerateService } from 'src/app/core/services/cargoGenerate.service';
import { SnackBarService } from 'src/app/core/services/snackBar.service';
import { CargoGenerateValidators } from 'src/app/core/validators/cargoGenerate.validator';
import { DateFormatPipe } from 'src/app/core/pipe/dateFormat.pipe';
import { NgxSpinnerService } from 'ngx-spinner';
import { Field } from 'src/app/core/interfaces/field';
import { Dialog } from 'src/app/core/resources/dialog';
import { DateManager } from 'src/app/core/managers/date.manager';
import { AuthService } from 'src/app/core/services/authentication.service';
import { HttpParams } from '@angular/common/http';
import { emailsToNotify } from 'src/app/core/enums/siigo-config.enum';
import { CatalogItem } from 'src/app/core/interfaces/catalogItem';
import { environment } from 'src/environments/environment';
import { Subscription } from 'rxjs';
import { EmailStructure } from 'src/app/core/interfaces/emailStructure';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { CompaniesService } from '../../administration/companies/list-companies.service';
import { ActivatedRoute, Router } from '@angular/router';
export type expensesAndIncomeTypes = 'accounting_voucher' | 'expenses';

@Component({
  selector: 'app-cargo-generate-filter',
  templateUrl: './cargo-generate-filter.component.html',
  styleUrls: ['./cargo-generate-filter.component.scss'],
  providers: [CargoGenerateService, DateFormatPipe, CargoGenerateValidators]
})
export class CargoGenerateFilterComponent implements OnInit {

  public reactiveForm: ReactiveForm;
  @Output() emitToParent: EventEmitter<any> = new EventEmitter();
  @Input() type: string = '';
  public isDialog = false;
  public optionsDateFrom = {
    minDate: new Date('3-1-2022'),
    maxDate: new Date()
  };
  public optionsDateUntil = {
    minDate: new Date(),
    maxDate: new Date()
  };
  public typeFiles: CatalogItem[] = [
    /*{
      id: 'receipts',
      name: 'Comprobante de Pago'
    }*/
  ];
  public monthsOptions: { label: string, value: Date }[] = [];
  public monthSelected = new FormControl(null, Validators.required);
  dateFormSub: Subscription;
  private companyEmails: EmailStructure[] = [];
  // Pestaña Egresos (en línea): empresa de transporte elegida en la pastilla.
  initialTransportCompanyId: string = null;
  private inlineTransportCompanyId: string = null;
  private inlineTransportCompanyResolved: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private cargoGenerateValidators: CargoGenerateValidators,
    private cargoGenerateService: CargoGenerateService,
    private snackBarService: SnackBarService,
    public utils: Utils,
    private spinner: NgxSpinnerService,
    public dialog: Dialog,
    private authService: AuthService,
    private dateFormatPipe: DateFormatPipe,
    @Inject(MAT_DIALOG_DATA) public dialogParams: {
      type: string,
      title: string,
      // Empresa de transporte de la vista que abrió el diálogo; null = sin acotar (comportamiento previo).
      transportCompanyId?: string
    },
    public dialogRef: MatDialogRef<CargoGenerateFilterComponent>,
    private listCompaniesService: CompaniesService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.initForm();
  }

  ngOnInit() {
    this.isDialog = !!this.dialogParams && !!this.dialogParams.type;
    // En línea (pestaña Egresos) comparte la empresa con "Comprobante Contable" vía ?transportCompanyId=.
    if (!this.isDialog) this.initialTransportCompanyId = this.route.snapshot.queryParams['transportCompanyId'] || null;
    const monthsNames = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
    this.monthsOptions = [];
    const now = new Date();
    for (let i = 11; i >= 0; i--) {
      const optionDate = new Date(now.getFullYear(), now.getMonth() - i, 1);
      const monthLabel = `${monthsNames[optionDate.getMonth()]} ${optionDate.getFullYear()}`;
      this.monthsOptions.push({ label: monthLabel, value: optionDate });
    }
    this.monthSelected.setValue(this.monthsOptions[this.monthsOptions.length - 1]);
    this.loadCompanyEmails();
  }

  private initForm(): void {
    this.reactiveForm = new ReactiveForm(
      this.formBuilder,
      this.cargoGenerateValidators.cargoGenerateModel
    );
    this.reactiveForm.setValidatorsForm(
      this.cargoGenerateValidators.cargoGenerateValidators,
      this.reactiveForm.form
    );
    this.dateFormSub = (this.reactiveForm.form as FormGroup).get('dateFrom').valueChanges.subscribe((value: Date) => {
      this.optionsDateUntil.minDate = this.utils.clone(value);
      const dateUntil = (this.reactiveForm.form as FormGroup).get('dateUntil').value;
      if (dateUntil && dateUntil < value)
        (this.reactiveForm.form as FormGroup).get('dateUntil').setValue(value);
    });
    let typeSended = this.type ? this.type : this.dialogParams.type;
    this.getAccountingTypes(typeSended === 'withoutPayment' ? 'accounting_voucher' : 'expenses');
  }

  public onChangeIncludeWithoutPayments(event: MatButtonToggleChange): void {
    if (event.value) {
      this.monthSelected.setValue(this.monthsOptions[this.monthsOptions.length - 1]);
      this.onChangeMonthSelected({ value: this.monthSelected.value });
    } else {
      this.reactiveForm.form.get('dateFrom').setValue(null);
      this.reactiveForm.form.get('dateUntil').setValue(null);
      this.monthSelected.setValue(null);
    }
  }

  public onChangeMonthSelected(event: { value: { value: Date, label: string } }): void {
    const monthDate: Date = event.value.value;
    this.reactiveForm.form.get('dateFrom').setValue(monthDate);
    const lastMonthDay: Date = DateManager.getLastMonthDay(monthDate);
    this.reactiveForm.form.get('dateUntil').setValue(DateManager.isSameOrBefore(lastMonthDay, new Date()) ? lastMonthDay : new Date());
  }

  public onSubmit(): void {
    // En línea se espera a que la pastilla resuelva la empresa (milisegundos) para no generar sin ella.
    if (!this.isDialog && !this.inlineTransportCompanyResolved) return;
    if (!this.isDialog) this.reactiveForm.form.get('includeWithoutPayments').setValue(null);
    if (this.reactiveForm.form.invalid) return this.snackBarService.openSnackBar('Faltan datos por llenar', undefined, 'alert');
    if (this.isDialog && !this.monthSelected.value) return this.snackBarService.openSnackBar('Debe seleccionar un mes', undefined, 'alert');
    if (this.isReceipts()) this.dialog.openDialog({ title: 'Observaciones', textArea: true }).then(response => this.generateFile(response.message)).catch(() => { });
    else this.dialog.openDialog({ title: `Deseas generar el archivo: ${this.getTypeFileSelected().name}?` }).then(this.generateFile.bind(this));

  }

  private loadCompanyEmails(): void {
    const companyId = this.authService.getCompanySaaS().companyId;

    if (!companyId) {
      this.companyEmails = [];
      return;
    }

    this.listCompaniesService.getEmailsFromCompany(companyId).subscribe({
      next: (emails: EmailStructure[]) => {
        this.companyEmails = emails || [];
      },
      error: (error) => {
        console.error('Error al obtener emails de la empresa:', error);
        this.companyEmails = [];
      }
    });
  }

  private getAccountingEmails(): string[] {
    return this.companyEmails
      .filter((email: EmailStructure) => email && email.type === 'accounting')
      .map((email: EmailStructure) => email.name);
  }

  private resetFieldsFilter(): void {
    this.reactiveForm.form.reset();
    this.optionsDateFrom.minDate = new Date('3-1-2022');
    this.optionsDateFrom.maxDate = new Date();
    this.optionsDateUntil.minDate = new Date();
  }

  /** En diálogo, la empresa del listado que lo abrió; en línea, la elegida en la pastilla. */
  get transportCompanyId(): string {
    if (this.isDialog) return this.dialogParams && this.dialogParams.transportCompanyId ? this.dialogParams.transportCompanyId : null;
    return this.inlineTransportCompanyId;
  }

  public onTransportCompanyChange(transportCompanyId: string): void {
    this.inlineTransportCompanyId = transportCompanyId;
    this.inlineTransportCompanyResolved = true;
    if (!transportCompanyId || this.route.snapshot.queryParams['transportCompanyId'] === transportCompanyId) return;
    // replaceUrl: cambiar de empresa no agrega pasos al historial del navegador.
    this.router.navigate([], { relativeTo: this.route, queryParams: { transportCompanyId }, queryParamsHandling: 'merge', replaceUrl: true });
  }

  private generateFile(message?: string): void {
    let field: Field;
    if (message) field = { field: message };
    const emails: string[] = this.getAccountingEmails();
    if (!emails.length) {
      this.snackBarService.openSnackBar('No hay correos de contabilidad configurados', undefined, 'error');
      return;
    }
    this.spinner.show();
    this.cargoGenerateService.cargoGenerate(this.reactiveForm.form.value, field, this.transportCompanyId).subscribe(
      (success: { message: string }) => {
        this.spinner.hide();
        this.dialog.openDialog({
          title: `¡Generación de ${this.getTypeFileSelected().name} en proceso!`,
          description: `Este proceso puede tardar varios minutos, al finalizar se enviarán los recibos a los siguientes correos:`,
          messageList: emails,
          icon: true,
          hideBtnCancel: true
        },
          true).finally(() => this.resetFieldsFilter());
        this.reactiveForm.form.patchValue(this.cargoGenerateValidators.cargoGenerateModel);
        if (this.dialogParams.type) this.dialogRef.close();
      },
      (error) => {
        this.emitToParent.emit();
        this.spinner.hide();
        this.reactiveForm.form.patchValue(this.cargoGenerateValidators.cargoGenerateModel);
        this.snackBarService.openSnackBar('Ocurrió un error al generar el archívo', undefined, 'error');
      }
    );
  }

  public getAccountingTypes(type?: expensesAndIncomeTypes | null): void {
    this.cargoGenerateService.getAccountingTypes(type).subscribe(
      (success: CatalogItem[]) => {
        this.typeFiles = success && success.length ? success : [];
      },
      (error) => {
        console.error(error);
        this.snackBarService.openSnackBar('Ocurrió un error al obtener los tipos de archivos', undefined, 'error');
        this.typeFiles = [];
      }
    )
  }

  private isReceipts(): boolean {
    return this.reactiveForm.form.get('typeFile').value === 'receipts';
  }

  private getTypeFileSelected(): CatalogItem {
    if (!this.utils.isEmpty(this.reactiveForm.form.get('typeFile').value)) {
      return this.typeFiles.filter((type) => type.id === this.reactiveForm.form.get('typeFile').value)[0];
    }
    return { id: null, name: 'Recibos de Pago' };
  }

  ngOnDestroy() {
    if (this.dateFormSub) this.dateFormSub.unsubscribe();
  }

}
